import ApiPaths from '../api-paths.js';

export default {
  list() {
    return axios.get(`${ ApiPaths.STAFF }/declaration-types?list`);
  },
};
